import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { NvDesignLibraryModule } from '../../../nvps-libraries/design/nv-design-library.module';
import { PageHeaderModule } from '../../shared/components/header/page-header/page-header.module';
import { CollegeListUploadComponent } from './college-list/college-list-upload.component';
import { DataUploadsComponent } from './data-uploads.component';
import { GradebookUploadComponent } from './gradebook/gradebook-upload.component';

@NgModule({
  imports: [CommonModule, PageHeaderModule, NvDesignLibraryModule],
  declarations: [DataUploadsComponent, CollegeListUploadComponent, GradebookUploadComponent],
  exports: [DataUploadsComponent, CollegeListUploadComponent, GradebookUploadComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class DataUploadsModule {}
